export default {
    title: 'Bankverbindungen',

    designation: 'Bezeichnung',
    iban: 'IBAN',
    bic: 'BIC',
    financial_institution: 'Geldinstitut',
    account_holder: 'Kontoinhaber',
    default: 'Standard Bankverbindung',

    designationDescription: 'Dies ist ein Pflichtfeld. Bitte legen Sie hier eine Bezeichnung fest für ihre interne Zuordnung des Zahlungseingangs von KJP-Fördermitteln.',
    bicDescription: 'Dieses Feld wird nur Verbänden angezeigt und wird ausschließlich für Auswertungen benötigt.',
    financialInstitutionDescription: 'Dieses Feld wird nur Verbänden angezeigt und wird ausschließlich für Auswertungen benötigt.',

    addBankAccount: 'Neue Bankverbindung',
    addNewBankAccount: 'Neue Bankverbindung hinzufügen',
    editBankAccount: 'Bankverbindung bearbeiten',
    saveBankAccount: 'Bankverbindung speichern',
    selectBankAccount: 'Bankverbindung auswählen',
    deleteBankAccount: 'Bankverbindung löschen',
    deleteBankAccountText: 'Möchten Sie diese Bankverbindung wirklich löschen?',
    deleteBankAccountNameText: 'Möchten Sie die Bankverbindung "{name}" wirklich löschen?',

    successfullySaved: 'Bankverbindung wurde erfolgreich gespeichert.',
    successfullyDeleted: 'Bankverbindung wurde erfolgreich gelöscht.',
    couldNotBeSaved: 'Bankverbindung konnte nicht gespeichert werden.',
    couldNotBeDeleted: 'Bankverbindung konnte nicht gelöscht werden.'
}